import { render, staticRenderFns } from "./FiltroExtrato.vue?vue&type=template&id=82bbd05a"
import script from "./FiltroExtrato.vue?vue&type=script&lang=js"
export * from "./FiltroExtrato.vue?vue&type=script&lang=js"
import style0 from "./FiltroExtrato.vue?vue&type=style&index=0&id=82bbd05a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports